module.exports = __webpack_public_path__ + "img/afterSalePerson.487357b2.png";